import {IonAvatar, IonBadge, IonButton, IonCol, IonIcon, IonNote, IonRouterLink, IonText, useIonRouter} from "@ionic/react";
import styles_ContractBonusDetailItem from "./ContractBonusDetailItem.module.scss";
import styles_CardFor_7_3 from "./CardFor_7_3.module.scss";
import {bookmark, bookmarkOutline, chatboxEllipses, chatboxEllipsesOutline, heart, heartOutline, star} from "ionicons/icons";
import Ln_TokenPictureSetCoverImg from "../pages/Ln_TokenPictureSetCoverImg";
import {ActionLink} from "./ActionLink";
import styles_Common from "../pages/Common.module.scss";
import moment from "moment";
import {useStoreState} from "pullstate";
import {AuthStore, UserCouponBookmarkStore} from "../store/Common_Store";
import {getPageData} from "../store/Selectors";
import {push_pg_3_11__AddArticleFavor, push_pg_3_11__AddCommentFavor, push_pg_3_11__RemoveArticleFavor} from "../store/Pg_3_Store";
import {push_pg_4_2__AddCouponBookmark, push_pg_4_2__RemoveCouponBookmark} from "../store/Pg_4_Store";
import indexBy from "underscore/modules/indexBy";


//#region +Event
// const navToPg_1_1 = () => {
//     router.push("/tabs/1_1", "forward", "push");
// }

//#region push register
const _push_pg_3_11__AddCommentFavor = async (commentId) => {
    debugger;

    if (await push_pg_3_11__AddCommentFavor({
        p1: commentId,
    })) {
        //navToPg_1_1();
    }
}

const _push_pg_4_2__AddCouponBookmark = async (postId) => {
    if (await push_pg_4_2__AddCouponBookmark({
        p1: postId,
    })) {
        //navToPg_1_1();
    }
}

const _push_pg_4_2__RemoveCouponBookmark = async (postId) => {
    if (await push_pg_4_2__RemoveCouponBookmark({
        p1: postId,
    })) {
        //navToPg_1_1();
    }
}

//#endregion

//#endregion

export const CardFor_7_3 = ({Item_Sdgs活動, fromHome = false, noLink = false}) => {
    const router = useIonRouter();

    // let Item_合約: any = Item_Sdgs活動?._合約;
    // if (!Item_合約) {
    //     return <>(ERROR:Item_合約)</>;
    // }
    //
    // let 剩下數量: number = parseInt(Item_Sdgs活動.CanUseTimes) - parseInt(Item_Sdgs活動.UseTimes);
    //
    // let endReason: any = null;
    // if (moment(Item_Sdgs活動.生效區間結束) <= moment()) {
    //     endReason = <span className="label-redeem ended">已過期</span>;
    // }
    // if (endReason === null && 剩下數量 <= 0) {
    //     endReason = <span className="label-redeem ended">兌換完畢</span>;
    // }


    return <>
        <ActionLink link={`/tabs/7_3_1/${Item_Sdgs活動.Sdgs活動Id}`} className={styles_CardFor_7_3.container} noLink={noLink}>
            <div className={styles_CardFor_7_3.containerInner}>
                <div className={styles_ContractBonusDetailItem.postBar}>
                    {Ln_TokenPictureSetCoverImg({
                        圖片組: Item_Sdgs活動.封面組,
                        名稱: 'cover',
                    })}
                </div>

                {/*<div className={styles_CardFor_7_2.nameBar}>*/}
                {/*    <div className="container">*/}
                {/*        /!*<div className="l">*!/*/}
                {/*        /!*    <IonAvatar className="avatar">*!/*/}
                {/*        /!*        {Ln_TokenPictureSetCoverImg({*!/*/}
                {/*        /!*            圖片組: Item_Token_會員公開.個人照片,*!/*/}
                {/*        /!*            名稱: 'cover',*!/*/}
                {/*        /!*        })}*!/*/}
                {/*        /!*    </IonAvatar>*!/*/}
                {/*        /!*</div>*!/*/}
                {/*        /!*<div className="r">*!/*/}
                {/*        /!*    {Item_Token_會員公開.暱稱}*!/*/}
                {/*        /!*</div>*!/*/}
                {/*        <div className="r2">*/}
                {/*            <div className="roundbg">*/}
                {/*                {Item_合約.Name}*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className={styles_CardFor_7_3.timeRangeBar}>
                    點數: {Item_Sdgs活動.完成可獲得點數 > 0 ? '+' : ''}{Item_Sdgs活動.完成可獲得點數}
                </div>

                <div className={styles_CardFor_7_3.timeRangeBar}>
                    {moment(Item_Sdgs活動.開始時間).format('YYYY/MM/DD  hh:mm A')} {Item_Sdgs活動._活動城市.顯示名稱}
                </div>

                <div className={styles_ContractBonusDetailItem.titleBar}>
                    {Item_Sdgs活動.活動名稱}
                </div>

            </div>
        </ActionLink>
    </>;
}
